import auth from './auth'
import scrollIt from './tools/scroll'

export default function (context, error) {
    if (!error || !error.hasOwnProperty('status')) {
        return;
    }
    if (error.status === 422) {
        scrollIt(
            document.body,
            300,
            'easeOutQuad'
        );
        context.$store.commit('setErrors', error.data)
        context.$noty.error("Please check the errors")
    }
    if (error.status === 401) {
        auth.logout();
        window.location.reload();
        // context.$router.push({
        //     path: '/login',
        //     query: { redirect: to.fullPath }
        // })
    }
}